module.exports = __webpack_public_path__ + "static/media/hinweis-krankenkassen-anerkannt-emr-zertifiziert.d0187c32.png";